var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuSetting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .MenuSetting_a {\n                ", "\n            }\n\n            .MenuSetting_b {\n                ", "\n                opacity: 0;\n            }\n\n            .MenuSetting_c {\n                clip-path: url(#MenuSetting_a);\n            }\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "MenuSetting_a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "MenuSetting_a",
    width: 24,
    height: 21.765
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23 -528)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "MenuSetting_b",
    width: 24,
    height: 24,
    transform: "translate(23 528)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-538 -342.37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(561 871.37)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "MenuSetting_c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "MenuSetting_a",
    d: "M577.007,893.246h-8.059a3.946,3.946,0,0,1-3.414-1.959l-4.03-6.94a4.062,4.062,0,0,1,0-3.918l4.03-6.94a3.945,3.945,0,0,1,3.414-1.959h8.059a1.119,1.119,0,1,1,0,2.239h-8.059a1.67,1.67,0,0,0-1.455.839l-4.03,6.94a1.785,1.785,0,0,0,0,1.679l4.03,7a1.67,1.67,0,0,0,1.455.839h8.059a1.67,1.67,0,0,0,1.455-.839l4.03-7a1.784,1.784,0,0,0,0-1.679l-3.078-5.317a1.133,1.133,0,1,1,1.9-1.231l.056.056,3.078,5.317a3.789,3.789,0,0,1,0,3.918l-4.03,6.94a3.884,3.884,0,0,1-3.414,2.015Zm0,0",
    transform: "translate(-561 -871.523)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "MenuSetting_a",
    d: "M748.24,1036.09a2.92,2.92,0,1,1,2.92-2.92,2.9,2.9,0,0,1-2.92,2.92Zm0-5.048a2.086,2.086,0,1,0,2.086,2.086,2.066,2.066,0,0,0-2.086-2.086Zm0,0",
    transform: "translate(-175.266 -150.937)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSetting);
export default __webpack_public_path__ + "static/media/MenuSetting.2c0b55486aa66166573f3ad0e3b93c5d.svg";
export { ForwardRef as ReactComponent };